export const tech = [
  {
    id: 1,
    title: "Frontend",
  },
  {
    id: 2,
    title: "Backend",
  },
  {
    id: 3,
    title: "Database",
  },
  {
    id: 4,
    title: "AI & ML",
  },
  {
    id: 5,
    title: "Security",
  },
  {
    id: 6,
    title: "Cloud Services",
  },
];

export const frontendImg = [
  {
    id: 1,
    img: require("../../../image/Dating/fr-img-one.webp"),
    bgClr: "#47d9f3",
    borderClr: "#47d9f3",
  },
  {
    id: 2,
    img: require("../../../image/Dating/fr-img-two.webp"),
    bgClr: "#5fb2fa",
    borderClr: "#5fb2fa",
  },
  {
    id: 3,
    img: require("../../../image/Dating/fr-img-three.webp"),
    bgClr: "#f89484",
    borderClr: "#f89484",
  },
  {
    id: 4,
    img: require("../../../image/Dating/fr-img-four.webp"),
    bgClr: "#f7d5ff",
    borderClr: "#f7d5ff",
  },
];

export const backendImg = [
  {
    id: 1,
    img: require("../../../image/Dating/bd-img-one.webp"),
    bgClr: "#82CD28",
    borderClr: "#82CD28",
  },
  {
    id: 2,
    img: require("../../../image/Dating/bd-img-two.webp"),
    bgClr: "#FFE262",
    borderClr: "#FFE262",
  },
  {
    id: 3,
    img: require("../../../image/Dating/bd-img-three.webp"),
    bgClr: "#6181B6",
    borderClr: "#6181B6",
  },
  {
    id: 4,
    img: require("../../../image/Dating/bd-img-four.webp"),
    bgClr: "#F68D8D",
    borderClr: "#F68D8D",
  },
];

export const databaseImg = [
  {
    id: 1,
    img: require("../../../image/Dating/db-img-one.webp"),
    bgClr: "#308BB1",
    borderClr: "#308BB1",
  },
  {
    id: 2,
    img: require("../../../image/Dating/db-img-twoo.webp"),
    bgClr: "#316192",
    borderClr: "#316192",
  },
  {
    id: 3,
    img: require("../../../image/Dating/db-img-three.webp"),
    bgClr: "#58AB54",
    borderClr: "#58AB54",
  },
  {
    id: 4,
    img: require("../../../image/Dating/db-img-four.webp"),
    bgClr: "#FFCA2B",
    borderClr: "#FFCA2B",
  },
];

export const aiImg = [
  {
    id: 1,
    img: require("../../../image/Dating/ai-img-one.webp"),
    bgClr: "#EB8C23",
    borderClr: "#EB8C23",
  },
  {
    id: 2,
    img: require("../../../image/Dating/ai-img-two.webp"),
    bgClr: "#10A37F",
    borderClr: "#10A37F",
  },
  {
    id: 3,
    img: require("../../../image/Dating/ai-img-three.webp"),
    bgClr: "#8DC73C",
    borderClr: "#8DC73C",
  },
];

export const securityImg = [
  {
    id: 1,
    img: require("../../../image/Dating/se-img-one.webp"),
    bgClr: "#47D9F3",
    borderClr: "#47D9F3",
  },
  {
    id: 2,
    img: require("../../../image/Dating/se-img-two.webp"),
    bgClr: "#E2FFEE",
    borderClr: "#E2FFEE",
  },
];

export const cloudImg = [
  {
    id: 1,
    img: require("../../../image/Dating/cl-img-one.webp"),
    bgClr: "#FF9900",
    borderClr: "#FF9900",
  },
  {
    id: 2,
    img: require("../../../image/Dating/cl-img-two.webp"),
    bgClr: "#4285F4",
    borderClr: "#4285F4",
  },
  {
    id: 3,
    img: require("../../../image/Dating/cl-img-three.webp"),
    bgClr: "#0089D6",
    borderClr: "#0089D6",
  },
];
